var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFitenoteSidebarActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.12676 1.15385V22.8462H18.8732V1.15385H5.12676ZM4.4507 0C4.20179 0 4 0.206638 4 0.461539V23.5385C4 23.7934 4.20179 24 4.4507 24H19.5493C19.7982 24 20 23.7934 20 23.5385V0.461538C20 0.206638 19.7982 0 19.5493 0H4.4507Z",
    fill: "#B2DDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1.57692C6 1.2583 6.25342 1 6.56604 1H17.434C17.7466 1 18 1.2583 18 1.57692V17.2692H17.3208V1.69231H6.67925V21.3077H14.3774V22H6.56604C6.25342 22 6 21.7417 6 21.4231V1.57692Z",
    fill: "#B2DDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.25C10 0.111929 10.0746 0 10.1667 0H13.8333C13.9254 0 14 0.111929 14 0.25V2.75C14 2.88807 13.9254 3 13.8333 3H10.1667C10.0746 3 10 2.88807 10 2.75V0.25Z",
    fill: "#B2DDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2106 17.5506L14.682 17.5506L14.682 22.0717L18.2106 17.5506ZM16.8549 18.2123L15.3436 18.2123L15.3436 20.1487L16.8549 18.2123Z",
    fill: "#B2DDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitenoteSidebarActiveIcon);
export default __webpack_public_path__ + "static/media/fitenote-sidebar-active-icon.d670e4eae50bce45efb7f5bc42414f5e.svg";
export { ForwardRef as ReactComponent };